import "slick-carousel";

import "slick-carousel/slick/slick.css";

$(document).ready(function() {

  $("#homeSlider").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $("#homePrev"),
    nextArrow: $("#homeNext"),
    appendDots: $("#homeDots"),
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true
  });

  console.log('test');

  $("#featuredSlider").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $("#featuredPrev"),
    nextArrow: $("#featuredNext"),
    appendDots: $("#featuredDots"),
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true
  });

  $("#featuredSliderMobile").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $("#featuredPrevMobile"),
    nextArrow: $("#featuredNextMobile"),
    appendDots: $("#featuredDotsMobile"),
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true
  });

});
